/* Beton Atelier theme JS */
(function () {
  'use strict';
  document.documentElement.classList.add('js');

  var toggle = document.querySelector('[data-nav-toggle]');
  var nav = document.getElementById('SiteNav');
  if (toggle && nav) {
    toggle.addEventListener('click', function () {
      var open = nav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    nav.addEventListener('click', function (e) {
      if (e.target.tagName === 'A') { nav.classList.remove('is-open'); toggle.setAttribute('aria-expanded', 'false'); }
    });
  }

  function paintCount(c){ document.querySelectorAll('[data-cart-count]').forEach(function(el){ el.textContent = c; el.classList.remove('is-bump'); void el.offsetWidth; el.classList.add('is-bump'); }); }
  function refreshCartCount(){ fetch('/cart.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.json();}).then(function(cart){ paintCount(cart.item_count); }).catch(function(){}); }
  document.addEventListener('cart:updated', refreshCartCount);

  function toast(msg){
    var t=document.createElement('div'); t.className='ba-toast';
    var c=document.createElement('span'); c.className='ba-toast__check'; c.setAttribute('aria-hidden','true'); c.textContent='✓';
    var m=document.createElement('span'); m.className='ba-toast__msg'; m.textContent=msg;
    var a=document.createElement('a'); a.className='ba-toast__link'; a.href='/cart'; a.textContent='Zum Warenkorb';
    t.appendChild(c); t.appendChild(m); t.appendChild(a); document.body.appendChild(t);
    requestAnimationFrame(function(){ t.classList.add('is-in'); });
    setTimeout(function(){ t.classList.remove('is-in'); setTimeout(function(){ t.remove(); },350); },3200);
  }
  window.betonAtelier={refreshCartCount:refreshCartCount,toast:toast};

  document.addEventListener('submit', function(e){
    var form=e.target;
    if(!form || form.tagName!=='FORM') return;
    var act=form.getAttribute('action')||'';
    if(act.indexOf('/cart/add')===-1) return;
    e.preventDefault();
    var btn=form.querySelector('[name=add]');
    var original=btn?btn.innerHTML:'';
    if(btn){ btn.disabled=true; btn.classList.add('is-loading'); btn.innerHTML='Wird hinzugefügt'; }
    var title=form.getAttribute('data-product-title')||'Artikel';
    fetch('/cart/add.js',{method:'POST',headers:{'Accept':'application/json'},body:new FormData(form)})
      .then(function(r){ if(!r.ok) throw new Error('add'); return r.json(); })
      .then(function(){ document.dispatchEvent(new CustomEvent('cart:updated')); if(btn){ btn.classList.remove('is-loading'); btn.classList.add('is-done'); btn.innerHTML='✓ Hinzugefügt'; } toast(title+' wurde hinzugefügt.'); setTimeout(function(){ if(btn){ btn.disabled=false; btn.classList.remove('is-done'); btn.innerHTML=original; } },1800); })
      .catch(function(){ if(btn){ btn.disabled=false; btn.classList.remove('is-loading'); btn.innerHTML=original; } form.submit(); });
  });

  var reveals=document.querySelectorAll('[data-reveal]');
  if(reveals.length){
    if('IntersectionObserver' in window && !(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches)){
      var io=new IntersectionObserver(function(entries){ entries.forEach(function(en){ if(en.isIntersecting){ en.target.classList.add('is-revealed'); io.unobserve(en.target); } }); }, {threshold:0.12});
      reveals.forEach(function(el){ io.observe(el); });
    } else { reveals.forEach(function(el){ el.classList.add('is-revealed'); }); }
  }
})();
